<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-19 15:52:01
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-19 19:35:28
 * @FilePath: \hzs-nutra-wecom-shop\src\views\customer\pointBill.vue
 * @Description: 积分账单
-->

<template>
  <div class="page-container">
    <div class="mainContent flex flex-col">
      <div class="pageHead fs0 rel">
        <div
          class="headInner abs pct100 h100 flex flex-col justify-sb align-center"
        >
          <div class="pct100 flex justify-sb align-center">
            <div class="flex align-center">
              <img
                :src="
                  state.userInfo?.user_base_info?.avatar_url || EmptyHeadImg
                "
                alt=""
                class="img"
              />

              <span class="userName">{{
                state.userInfo?.user_base_info?.name
              }}</span>
            </div>

            <p class="totalPoint">{{ state.statistics?.current_points }}</p>
          </div>

          <div class="headerStatistics pct100 flex justify-sa align-center">
            <div class="statisticsItem">
              <p>行为积分</p>
              <p>{{ state.statistics?.point1 || 0 }}</p>
            </div>
            <van-divider :hairline="false" vertical></van-divider>
            <div class="statisticsItem">
              <p>消费积分</p>
              <p>{{ state.statistics?.point2 || 0 }}</p>
            </div>
            <van-divider :hairline="false" vertical></van-divider>
            <div class="statisticsItem">
              <p>推广积分</p>
              <p>{{ state.statistics?.point2 || 0 }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="listContainer flex1 ovh">
        <div class="pointTabs flex justify-sb align-center">
          <p
            class="tabItem"
            :class="state.billType === 0 ? 'active' : ''"
            @click="handleChangeBillType(0)"
          >
            全部
          </p>
          <p
            class="tabItem"
            :class="state.billType === 1 ? 'active' : ''"
            @click="handleChangeBillType(1)"
          >
            收入
          </p>
          <p
            class="tabItem"
            :class="state.billType === -1 ? 'active' : ''"
            @click="handleChangeBillType(-1)"
          >
            支出
          </p>
        </div>

        <van-pull-refresh
          v-if="state.listData.length"
          v-model="state.isRefresh"
          @refresh="onRefresh"
        >
          <van-list
            v-model:loading="state.listLoading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="item in state.listData"
              :key="item"
              class="billItem flex justify-sb align-center"
              @click="goto(item)"
            >
              <div class="left">
                <div class="flex">
                  <p class="name">{{ item.description }}</p>
                  <p class="shopName" v-if="item?.other">{{ item.shopName }}</p>
                </div>

                <p class="time">{{ item.created_at }}</p>
              </div>

              <div class="right flex align-center">
                <i class="coin db icon"></i>
                <span class="point">
                  {{
                    item.point_before_change < item.point_after_change
                      ? "+"
                      : "-"
                  }}{{ Math.abs(item.point_change) }}积分</span
                >
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <div v-else class="emptyBox flex align-center justify-sc">
          <van-empty
            :image="emptyCustomerImg"
            image-size="150"
            description="没有该客户？去创建新客户"
          />
        </div>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="handleBack"
      >
        返 回
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomerApi from "@/utils/api/customer";
import EmptyHeadImg from "@/assets/img/icons/emptyHeadImg.png";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { user_uuid, shop_uuid } = route.query;
const state = reactive({
  billType: 0,

  listData: [],

  userInfo: {},
  statistics: {},

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,
});

// --------------------------------------- 方法、事件
onMounted(async () => {
  await getInfo();
  getList();
  getStatistics();
});

// 下拉刷新回调
const onRefresh = async () => {
  // 重置列表状态
  state.finished = false;
  state.listLoading = true; // 先让 List 进入 loading 状态（或者直接在这里处理）

  state.listData = [];

  state.pagination.lastPage = state.pagination.page;
  state.pagination.lastPageSize = state.pagination.pageSize;

  state.pagination.page = 1;
  state.pagination.pageSize =
    state.pagination.lastPage * state.pagination.lastPageSize;

  await GroupService.getList();
  await nextTick();
  state.isRefresh = false;
  state.pagination.pageSize = state.pagination.lastPageSize;
  state.listLoading = false;
};
// 上拉加载回调 (由 van-list 触发)
const onLoad = async () => {
  // 如果是刷新过程中触发的 load，则不重复请求
  if (state.isRefresh) {
    state.listLoading = false;
    return;
  }

  if (state.listData.length < state.pagination.total) {
    state.pagination.page += 1;
    await GroupService.getList();
  }

  state.finished = true;
  state.listLoading = false;
};

// 切换账单类型
function handleChangeBillType(type) {
  state.billType = type;
  getList();
}

function handleBack() {
  router.go(-1);
}
// --------------------------------------- 请求
function getList() {
  const params = {
    user_uuid,
    transaction_type: state.billType,
    page: state.pagination.page,
    page_size: state.pagination.pageSize,
  };
  CustomerApi._customerBillList(params).then((res) => {
    state.listData = res?.data || [];
  });
}
function getStatistics() {
  CustomerApi._customerPointStatistics({
    user_uuid,
    shop_uuid: state.userInfo?.user_shop_info?.shop_uuid,
  }).then((res) => {
    state.statistics = res?.data || {};
  });
}
async function getInfo() {
  let res = await CustomerApi._customerInfo({ user_uuid }).catch((err) => {});
  state.userInfo = res?.data || {};
}
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.mainContent {
  padding: 0;

  .pageHead {
    padding-top: 44.27%;
    background: url("@/assets/img/customer/pointBillHeadBg.png") no-repeat
      center center / 100% 100%;

    .headInner {
      top: 0;
      left: 0;
      padding: 18px;

      .img {
        width: 48px;
        height: 48px;
        border-radius: 100%;
      }

      .userName {
        height: 25px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #3c211f;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 8px;
      }
      .totalPoint {
        height: 39px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #3c211f;
        line-height: 39px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .headerStatistics {
        height: 78px;
        margin-top: 20px;
        background: rgba(255, 255, 255, 0.4);
        border-radius: 8px 8px 8px 8px;

        .statisticsItem {
          p:nth-child(1) {
            height: 20px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          p:nth-child(2) {
            height: 23px;
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 20px;
            line-height: 23px;
            color: #3c211f;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }

        .van-divider {
          height: 20px;
          background: rgba(0, 0, 0, 0.2);
          margin: 0;
        }
      }
    }
  }

  .listContainer {
    padding: 10px 18px;

    .pointTabs {
      height: 53px;
      padding: 0 49px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;

      .tabItem {
        height: 22px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        text-align: left;
        font-style: normal;
        text-transform: none;

        &.active:after {
          display: block;
          content: "";
          width: 18px;
          height: 2px;
          margin: 4px auto 0;
          background: #dcbb89;
          border-radius: 9px 9px 9px 9px;
        }
      }
    }

    .emptyBox,
    .van-pull-refresh {
      height: calc(100% - 53px - 10px);
      margin-top: 10px;
      overflow: auto;

      .billItem {
        height: 84px;
        background: #ffffff;
        padding: 19px 15px;
        border-radius: 12px 12px 12px 12px;

        .left {
          .name {
            height: 22px;
            line-height: 22px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .shopName {
            height: 22px;
            line-height: 22px;
            background: #dcbb89;
            border-radius: 2px 2px 2px 2px;
            margin-left: 14px;

            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 500;
            font-size: 13px;
            color: #ffffff;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .time {
            height: 20px;
            line-height: 20px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-top: 4px;
          }
        }
        .right {
          .icon {
            width: 24px;
            height: 24px;
            background: url("@/assets/img/icons/coin.png") no-repeat center;
          }
          .point {
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #dcbb89;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin-left: 6px;
          }
        }
      }
    }
  }
}
</style>
